import MidiEffect from '../MidiEffect.js';
import Valuable from './Valuable.js';

export const CHORD_TYPE = 1;
export const VOICE  = 2;
export const VOICE_TRANSFORM = 3;

export class ChordEffect extends MidiEffect {
    constructor(track, numeral) {
        super("Chord Type", track, 1);
        this.numeral = numeral;

        // mapping from position -> chord to go from here
        // updated by user as they figure out the feel
        this.nextChords = {};
    }

    onNewStep() {
        this.active = false;
        super.onNewStep();
    }

    output() {
        this.active = this.triggers.length > 0;
        return this.triggers || [];
    }

    getChordEffectType() {
        return CHORD_TYPE;
    }

    getJson() {
        return {
            ... super.getJson(),
            numeral: this.numeral
        };
    }

    fromJson(json) {
        super.fromJson(json);
        this.numeral = json.numeral;
    }

    get prettyName() {
        switch (this.numeral) {
        case 1:
            return 'I';
        case 2:
            return 'II';
        case 3:
            return 'III';
        case 4:
            return 'IV';
        case 5:
            return 'V';
        case 6:
            return 'VI';
        case 7:
            return 'VII';
        default:
            return 'All Chords';
        }
    }
}

export class VoiceEffect extends Valuable(MidiEffect) {
    constructor(track, degree) {
        super("Voice", track, 2);
        this.initValueParameter(0, 13, degree);
    }

    get degree() {
        return this.value;
    }

    getText() {
        return '';
    }

    set degree(x) {
        return this.value = x;
    }

    onNewStep() {
        this.active = false;
        super.onNewStep();
    }

    output() {
        let triggers = this.triggers || [];
        this.active = triggers.length > 0;

        for (let trigger of triggers) {
            for (let v of trigger.stepData.voices) {
                if (v.voice === undefined) {
                    v.voice = this.degree;
                }
            }
            trigger.stepData.voices.push({
                voice: this.degree
            });
        }
        return triggers;
    }

    getJson() {
        return {
            ... super.getJson(),
            ... super.getValueJson()
        };
    }

    fromJson(json) {
        super.fromJson(json);
        json.value = json.degree;
        this.fromValueJson(json);
    }

    getChordEffectType() {
        return VOICE;
    }

    get prettyName() {
        switch (this.degree) {
        case 1:
            return "1st";
        case 2:
            return "2nd";
        case 3:
            return "3rd";
        default:
            return this.degree + "th";
        }
    }
}

/**
 * 
 */
export class VoiceTransformEffect extends Valuable(MidiEffect) {
    constructor(name, track, min, max, defaultValue) {
        super(name, track, 1);
        this.initValueParameter(min, max, defaultValue);
    }

    onNewStep() {
        this.active = false;
        super.onNewStep();
    }

    getText() {
        if (this.value !== undefined) {
            return this.value;
        }
        return '';
    }

    transform(transpose) {
        return transpose;
    }

    getChordEffectType() {
        return VOICE_TRANSFORM;
    }

    fromJson(json) {
        super.fromJson(json);
        this.fromValueJson(json);
    }

    getJson() {
        return {
            ... super.getJson(),
            ... super.getValueJson()
        };
    }
}

export class OctaveEffect extends VoiceTransformEffect {
    constructor(track) {
        super("Octave", track, -4, 4, -1);
    }

    output() {
        let triggers = this.triggers || [];
        this.active = triggers.length > 0;

        for (let trigger of triggers) {
            // first find one that has no octave, if thats the case then
            // add the octave here
            let noOctave = trigger.stepData.voices.filter(x => x.octave === undefined);
            if (noOctave.length > 0) {
                noOctave.forEach(v => v.octave = this.value);
            } else {
                // if theres none that have no octave then add a voice
                let voice = trigger.stepData.voices[0] || {voice: 1};
                voice.octave = this.value;
                trigger.stepData.voices.push(voice);
            }
        }
        return triggers;
    }


    transform(transpose) {
        return transpose + this.value * 12;
    }
}

